(function () {
  'use strict';
  // Both snippets/mz-wish-icon.liquid (header, every page) and
  // sections/mz-wishlist-page.liquid inject this file, so on /pages/wishlist it
  // executes twice. Two delegated listeners = every heart click toggles twice,
  // i.e. adds then instantly removes. Bail on the second run.
  if (window.MzWishlist) return;

  var KEY = 'mz_wishlist';

  function get() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function save(l) {
    try {
      localStorage.setItem(KEY, JSON.stringify(l));
    } catch (e) {}
  }
  function find(id) {
    var l = get();
    for (var i = 0; i < l.length; i++) if (String(l[i].id) === String(id)) return l[i];
    return null;
  }
  function isWished(id) {
    return !!find(id);
  }
  function add(item) {
    var l = get();
    if (!find(item.id)) {
      l.unshift(item);
      save(l);
      updateCount();
      return true;
    }
    return false;
  }
  function remove(id) {
    save(
      get().filter(function (i) {
        return String(i.id) !== String(id);
      })
    );
    updateCount();
  }
  function toggle(item) {
    if (isWished(item.id)) {
      remove(item.id);
      return false;
    }
    add(item);
    return true;
  }

  // Titles/vendors are injected into innerHTML below. They arrive from
  // getAttribute (already un-escaped), so anything with & < > " would break the
  // markup without this.
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function updateCount() {
    var c = get().length;
    document.querySelectorAll('.mz-wish-count').forEach(function (el) {
      el.textContent = c;
      el.style.display = c > 0 ? 'flex' : 'none';
    });
  }

  function syncBtns() {
    document.querySelectorAll('[data-wishlist-id]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-id');
      var svg = btn.querySelector('svg');
      if (isWished(id)) {
        btn.classList.add('wished');
        if (svg) svg.style.fill = '#a3188c';
      } else {
        btn.classList.remove('wished');
        if (svg) svg.style.fill = 'none';
      }
    });
  }

  function toast(msg, link) {
    var e = document.querySelector('.mz-wish-toast');
    if (e) e.remove();
    var t = document.createElement('div');
    t.className = 'mz-wish-toast';
    t.innerHTML = '<span>' + esc(msg) + '</span>' + (link ? '<a href="/pages/wishlist">View</a>' : '');
    document.body.appendChild(t);
    requestAnimationFrame(function () {
      t.classList.add('show');
    });
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () {
        t.remove();
      }, 300);
    }, 2800);
  }

  /* ── Heart toggle (delegated, works on every card grid) ─────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var item = {
      id: btn.getAttribute('data-wishlist-id'),
      title: btn.getAttribute('data-wishlist-title') || '',
      price: btn.getAttribute('data-wishlist-price') || '',
      img: btn.getAttribute('data-wishlist-img') || '',
      url: btn.getAttribute('data-wishlist-url') || '',
      variant: btn.getAttribute('data-wishlist-variant') || '',
      variants: parseInt(btn.getAttribute('data-wishlist-variants') || '1', 10) || 1,
      vendor: btn.getAttribute('data-wishlist-vendor') || '',
    };
    var added = toggle(item);
    syncBtns();
    toast(added ? 'Added to wishlist' : 'Removed from wishlist', added);
  });

  /* ── Move to cart ───────────────────────────────────────────────────── */
  function resolveVariant(item) {
    // More than one variant means a size/colour choice we can't make for them.
    if (item.variants > 1) return Promise.resolve({ redirect: true });
    if (item.variant) return Promise.resolve({ variantId: item.variant });
    // Legacy entries saved before variant ids were stored.
    return fetch(item.url + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        var vs = p.variants || [];
        if (vs.length > 1) return { redirect: true };
        var avail = vs.filter(function (v) {
          return v.available;
        });
        return { variantId: avail.length ? avail[0].id : null };
      });
  }

  function addToCart(variantId) {
    var cd = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (cd && typeof cd.getSectionsToRender === 'function') {
      body.sections = cd.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (d) {
          return { ok: r.ok, data: d };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || 'Could not add to cart');
          return false;
        }
        if (cd && typeof cd.renderContents === 'function' && res.data.sections) {
          cd.renderContents(res.data); // re-renders drawer + bubble, then opens it
        } else {
          toast('Added to cart');
        }
        return true;
      });
  }

  function moveToCart(id, btn) {
    var item = find(id);
    if (!item) return;
    btn.classList.add('is-busy');
    btn.disabled = true;
    resolveVariant(item)
      .then(function (res) {
        if (res.redirect) {
          window.location.href = item.url;
          return;
        }
        if (!res.variantId) {
          toast('This product is currently unavailable');
          return;
        }
        return addToCart(res.variantId).then(function (ok) {
          // "Move" — it only leaves the wishlist once it's safely in the cart.
          if (ok) {
            remove(item.id);
            syncBtns();
            renderPage();
          }
        });
      })
      .catch(function () {
        toast('Could not add to cart');
      })
      .finally(function () {
        btn.classList.remove('is-busy');
        btn.disabled = false;
      });
  }

  /* ── Wishlist page rendering ────────────────────────────────────────── */
  function renderPage() {
    var c = document.querySelector('#mz-wishlist-container');
    if (!c) return;
    var l = get();

    var ci = document.querySelector('#mz-wishlist-count');
    if (ci) ci.textContent = l.length + ' item' + (l.length !== 1 ? 's' : '');

    var clear = document.querySelector('.mz-wlp__clear');
    if (clear) clear.style.display = l.length ? '' : 'none';

    if (l.length === 0) {
      c.innerHTML =
        '<div class="mz-wlp__empty">' +
        '<div class="mz-wlp__empty-icon"><svg viewBox="0 0 24 24" width="56" height="56" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg></div>' +
        '<h2>Your wishlist is empty</h2>' +
        '<p>Tap the heart on any product to save it here for later.</p>' +
        '<a href="/collections/all" class="mz-wlp__cta">Browse products</a>' +
        '</div>';
      return;
    }

    var h = '<div class="mz-wlp__grid">';
    l.forEach(function (item) {
      var url = esc(item.url);
      var multi = (item.variants || 1) > 1;
      h +=
        '<article class="mz-wlp__card">' +
        '<div class="mz-wlp__media">' +
        '<a href="' + url + '" class="mz-wlp__img" tabindex="-1" aria-hidden="true">' +
        (item.img
          ? '<img src="' + esc(item.img) + '" alt="" loading="lazy">'
          : '<span class="mz-wlp__img-ph"></span>') +
        '</a>' +
        '<button type="button" class="mz-wlp__remove" data-mz-remove="' + esc(item.id) + '" aria-label="Remove ' + esc(item.title) + ' from wishlist">' +
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '</div>' +
        '<div class="mz-wlp__body">' +
        (item.vendor ? '<p class="mz-wlp__vendor">' + esc(item.vendor) + '</p>' : '') +
        '<h3 class="mz-wlp__title"><a href="' + url + '">' + esc(item.title) + '</a></h3>' +
        '<p class="mz-wlp__price">' + esc(item.price) + '</p>' +
        '<div class="mz-wlp__actions">' +
        '<button type="button" class="mz-wlp__move" data-mz-move="' + esc(item.id) + '">' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
        '<span>' + (multi ? 'Choose options' : 'Move to cart') + '</span>' +
        '</button>' +
        '<a href="' + url + '" class="mz-wlp__view">View details</a>' +
        '</div>' +
        '</div>' +
        '</article>';
    });
    h += '</div>';
    c.innerHTML = h;
  }

  // Delegated so it survives every re-render of the grid.
  document.addEventListener('click', function (e) {
    var mv = e.target.closest('[data-mz-move]');
    if (mv) {
      e.preventDefault();
      moveToCart(mv.getAttribute('data-mz-move'), mv);
      return;
    }
    var rm = e.target.closest('[data-mz-remove]');
    if (rm) {
      e.preventDefault();
      remove(rm.getAttribute('data-mz-remove'));
      syncBtns();
      renderPage();
    }
  });

  window.MzWishlist = {
    remove: function (id) {
      remove(id);
      syncBtns();
      renderPage();
    },
    clearAll: function () {
      save([]);
      updateCount();
      syncBtns();
      renderPage();
    },
    isWished: isWished,
    getList: get,
  };

  function init() {
    updateCount();
    syncBtns();
    renderPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
